export default __webpack_public_path__ + "static/media/pantry1-afterI-1024w.b3b616e3.webp";